import { Box, Container } from '@hover/blueprint';
import React from 'react';
import CareersOurToolsDesktop from './CareersOurToolsDekstop';
import CareersOurToolsMobile from './CareersOurToolsMobile';
import { useInterSectionObserver } from '../../../hooks';

interface Props {
  setCurrentSection: React.Dispatch<React.SetStateAction<string>>;
}

const CareersOurTools: React.FC<Props> = ({ setCurrentSection }) => {
  const ourToolsRef = useInterSectionObserver(
    isIntersecting => {
      if (isIntersecting) {
        setCurrentSection('Our Tools');
      }
    },
    {
      root: null,
      rootMargin: '0px',
      threshold: 0.3,
    },
  );

  return (
    <Container
      maxW="6xl"
      ref={ourToolsRef.elementRef}
      pl={400}
      mt={{ base: 700, desktop: '-150px' }}
      mb={{ base: 1000, desktop: '-100px' }}
      position="relative"
    >
      <Box
        id="our-tools"
        position={{ desktop: 'absolute' }}
        display={{ base: 'none', desktop: 'block' }}
        w={0}
        h={0}
        top="200px"
      />
      <CareersOurToolsDesktop />
      <CareersOurToolsMobile />
    </Container>
  );
};

export default CareersOurTools;
